import type { IntlShape } from 'react-intl';

export const WAYPOINT_DECIMAL_PLACES = 6;
export const WAYPOINT_ZOOM = 15;
export const WAYPOINT_TRIGGER_PARAM = 'waypoint';
export const COMMUNITY_WAYPOINTS_TRIGGER_PARAM = 'community_waypoints';
export const WAYPOINT_LAT_PARAM = 'waypoint_lat';
export const WAYPOINT_LNG_PARAM = 'waypoint_lng';

export const getGeneralError = (intl: IntlShape) => ({
  iconCode: 'error',
  message: intl.formatMessage({ defaultMessage: "We couldn't complete this action. Give it another try!" })
});
